// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-number[data-v-6df3ca0a] {\n  padding-left: 4px;\n  padding-right: 4px;\n  margin-left: 3px;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #2C3E50;\n}\n.button-number-major[data-v-6df3ca0a] {\n  padding-left: 4px;\n  padding-right: 4px;\n  margin-left: 3px;\n  background-color: #FF5722;\n  color: #fff;\n}\n", ""]);
